var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-mobile-full-screen-container",
    { attrs: { "max-show-size": "md" } },
    [
      _c("app-toolbar"),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-container", "no-padding": "", "y-snap": "" } },
        [
          _c("app-properties", { attrs: { state: _vm.state } }),
          _c("app-rows", { attrs: { state: _vm.state } }),
          _vm.state.sale.Rows.length > 0
            ? _c("app-frequency-settings-edit", { attrs: { state: _vm.state } })
            : _vm._e(),
          _vm.state.sale.Rows.length > 0
            ? _c("app-finish", { attrs: { state: _vm.state } })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }